export default __webpack_public_path__ + "static/media/cirsolar-logo-dark.fd3bf085.png";